export const leadValues = {
	rateTypes: [
		{ key: '30-Yr Fixed', value: '30yr Fixed' },
		{ key: '15-Yr Fixed', value: '15yr Fixed' },
		{ key: 'ARM', value: 'ARM' },
		{ key: 'Don\'t Know', value: 'Don\'t Know' },
	],
	propertyTypes: [
		{ key: 'Single', value: 'Single Family' },
		{ key: 'Multi', value: 'Multi Family' },
		{ key: 'Condo', value: 'Condo' },
		{ key: 'Town House', value: 'Town House' },
		{ key: 'Cooperative', value: 'Cooperative' },
		{ key: 'Mobile', value: 'Mobile' },
		{ key: 'Manufactured', value: 'Manufactured' },
	],
	propertyUses: [
		{ key: 'primary', value: 'Primary Home' },
		{ key: 'secondary', value: 'Secondary Home' },
		{ key: 'investment', value: 'Investment Property' },
	],
	buyingProcess: [
		{ key: 'just_thinking', value: 'Just Thinking' },
		{ key: 'days_from_buying', value: 'Purchasing within 90 days' },
		{ key: 'found_home', value: 'Found a home' },
		{ key: 'signed_agreement', value: 'Signed Purchase Agreement' },
	],
	yesNos: [
		{ key: 'yes', value: 'Yes' },
		{ key: 'no', value: 'No' },
	],
	purchasePrices: [
		{ key: 60000, value: '$60,000 or less' },
		{ key: 65000, value: '$60,001 - $65,000' },
		{ key: 70000, value: '$65,001 - $70,000' },
		{ key: 75000, value: '$70,001 - $75,000' },
		{ key: 80000, value: '$75,001 - $80,000' },
		{ key: 85000, value: '$80,001 - $85,000' },
		{ key: 90000, value: '$85,001 - $90,000' },
		{ key: 95000, value: '$90,001 - $95,000' },
		{ key: 100000, value: '$95,001 - $100,000' },
		{ key: 105000, value: '$100,001 - $105,000' },
		{ key: 110000, value: '$105,001 - $110,000' },
		{ key: 115000, value: '$110,001 - $115,000' },
		{ key: 120000, value: '$115,001 - $120,000' },
		{ key: 125000, value: '$120,001 - $125,000' },
		{ key: 130000, value: '$125,001 - $130,000' },
		{ key: 135000, value: '$130,001 - $135,000' },
		{ key: 140000, value: '$135,001 - $140,000' },
		{ key: 145000, value: '$140,001 - $145,000' },
		{ key: 150000, value: '$145,001 - $150,000' },
		{ key: 155000, value: '$150,001 - $155,000' },
		{ key: 160000, value: '$155,001 - $160,000' },
		{ key: 165000, value: '$160,001 - $165,000' },
		{ key: 170000, value: '$165,001 - $170,000' },
		{ key: 175000, value: '$170,001 - $175,000' },
		{ key: 180000, value: '$175,001 - $180,000' },
		{ key: 185000, value: '$180,001 - $185,000' },
		{ key: 190000, value: '$185,001 - $190,000' },
		{ key: 195000, value: '$190,001 - $195,000' },
		{ key: 200000, value: '$195,001 - $200,000' },
		{ key: 210000, value: '$200,001 - $210,000' },
		{ key: 220000, value: '$210,001 - $220,000' },
		{ key: 230000, value: '$220,001 - $230,000' },
		{ key: 240000, value: '$230,001 - $240,000' },
		{ key: 250000, value: '$240,001 - $250,000' },
		{ key: 260000, value: '$250,001 - $260,000' },
		{ key: 270000, value: '$260,001 - $270,000' },
		{ key: 280000, value: '$270,001 - $280,000' },
		{ key: 290000, value: '$280,001 - $290,000' },
		{ key: 300000, value: '$290,001 - $300,000' },
		{ key: 310000, value: '$300,001 - $310,000' },
		{ key: 320000, value: '$310,001 - $320,000' },
		{ key: 330000, value: '$320,001 - $330,000' },
		{ key: 340000, value: '$330,001 - $340,000' },
		{ key: 350000, value: '$340,001 - $350,000' },
		{ key: 360000, value: '$350,001 - $360,000' },
		{ key: 370000, value: '$360,001 - $370,000' },
		{ key: 380000, value: '$370,001 - $380,000' },
		{ key: 390000, value: '$380,001 - $390,000' },
		{ key: 400000, value: '$390,001 - $400,000' },
		{ key: 420000, value: '$400,001 - $420,000' },
		{ key: 440000, value: '$420,001 - $440,000' },
		{ key: 460000, value: '$440,001 - $460,000' },
		{ key: 480000, value: '$460,001 - $480,000' },
		{ key: 500000, value: '$480,001 - $500,000' },
		{ key: 520000, value: '$500,001 - $520,000' },
		{ key: 540000, value: '$520,001 - $540,000' },
		{ key: 560000, value: '$540,001 - $560,000' },
		{ key: 580000, value: '$560,001 - $580,000' },
		{ key: 600000, value: '$580,001 - $600,000' },
		{ key: 620000, value: '$600,001 - $620,000' },
		{ key: 640000, value: '$620,001 - $640,000' },
		{ key: 660000, value: '$640,001 - $660,000' },
		{ key: 680000, value: '$660,001 - $680,000' },
		{ key: 700000, value: '$680,001 - $700,000' },
		{ key: 720000, value: '$700,001 - $720,000' },
		{ key: 740000, value: '$720,001 - $740,000' },
		{ key: 760000, value: '$740,001 - $760,000' },
		{ key: 780000, value: '$760,001 - $780,000' },
		{ key: 800000, value: '$780,001 - $800,000' },
		{ key: 820000, value: '$800,001 - $820,000' },
		{ key: 840000, value: '$820,001 - $840,000' },
		{ key: 860000, value: '$840,001 - $860,000' },
		{ key: 880000, value: '$860,001 - $880,000' },
		{ key: 900000, value: '$880,001 - $900,000' },
		{ key: 920000, value: '$900,001 - $920,000' },
		{ key: 940000, value: '$920,001 - $940,000' },
		{ key: 960000, value: '$940,001 - $960,000' },
		{ key: 980000, value: '$960,001 - $980,000' },
		{ key: 1000000, value: '$980,001 - $1,000,000' },
		{ key: 1100000, value: '$1,000,001 - $1,100,000' },
		{ key: 1200000, value: '$1,100,001 - $1,200,000' },
		{ key: 1300000, value: '$1,200,001 - $1,300,000' },
		{ key: 1400000, value: '$1,300,001 - $1,400,000' },
		{ key: 1500000, value: '$1,400,001 - $1,500,000' },
		{ key: 1600000, value: '$1,500,001 - $1,600,000' },
		{ key: 1700000, value: '$1,600,001 - $1,700,000' },
		{ key: 1800000, value: '$1,700,001 - $1,800,000' },
		{ key: 1900000, value: '$1,800,001 - $1,900,000' },
		{ key: 2000000, value: '$1,900,001 - $2,000,000' },
		{ key: 2000001, value: 'Over $2,000,000' },
	],
	creditRatings: [
		{ key: 'Excellent', value: 'Excellent (720 or above)' },
		{ key: 'Good', value: 'Good (640 - 719)' },
		{ key: 'Fair', value: 'Fair (590 - 639)' },
		{ key: 'Poor', value: 'Poor (589 or below)' },
		{ key: 'Good', value: 'Don\'t Know' },
	],
	downPayments: [
		{ key: '0', value: 'Zero Down' },
		{ key: '3.5% down', value: '3.5% Down' },
		{ key: '5% down', value: '5% Down' },
		{ key: '10% down', value: '10% Down' },
		{ key: '15% down', value: '15% Down' },
		{ key: '20% down', value: '20% Down' },
		{ key: '25% down', value: '25% Down' },
		{ key: '30% down', value: '30% Down' },
		{ key: '35% down', value: '35% Down' },
		{ key: '40% down', value: '40% Down' },
		{ key: '45% down', value: '45% Down' },
		{ key: '50% down', value: '50% Down', },
		{ key: '55% down', value: '55% Down' },
		{ key: '60% down', value: '60% Down' },
		{ key: '65% down', value: '65% Down' },
		{ key: '70% down', value: '70% Down' },
		{ key: '75% down', value: '75% Down' },
		{ key: '80% down', value: '80% Down' },
		{ key: '85% down', value: '85% Down' },
		{ key: '90% down', value: '90% Down' },
		{ key: '95% down', value: '95% Down' },
		{ key: 'other', value: 'Other Down' },
	],
	cashOuts: [
		{ key: 0, value: 'None' },
		{ key: 2500, value: 'Under $5,000' },
		{ key: 7500, value: '$5,001 - $10,000' },
		{ key: 12500, value: '$10,001 - $15,000' },
		{ key: 17500, value: '$15,001 - $20,000' },
		{ key: 22500, value: '$20,001 - $25,000' },
		{ key: 27500, value: '$25,001 - $30,000' },
		{ key: 32500, value: '$30,001 - $35,000' },
		{ key: 37500, value: '$35,001 - $40,000' },
		{ key: 42500, value: '$40,001 - $45,000' },
		{ key: 47500, value: '$45,001 - $50,000' },
		{ key: 55000, value: '$50,001 - $60,000' },
		{ key: 65000, value: '$60,001 - $70,000' },
		{ key: 75000, value: '$70,001 - $80,000' },
		{ key: 85000, value: '$80,001 - $90,000' },
		{ key: 95000, value: '$90,001 - $100,000' },
		{ key: 100000, value: '$100,000 or more' },
	],
	propertyValues: [
		{ key: 60000, value: '$60,000 or less' },
		{ key: 65000, value: '$60,001 - $65,000' },
		{ key: 70000, value: '$65,001 - $70,000' },
		{ key: 75000, value: '$70,001 - $75,000' },
		{ key: 80000, value: '$75,001 - $80,000' },
		{ key: 85000, value: '$80,001 - $85,000' },
		{ key: 90000, value: '$85,001 - $90,000' },
		{ key: 95000, value: '$90,001 - $95,000' },
		{ key: 100000, value: '$95,001 - $100,000' },
		{ key: 105000, value: '$100,001 - $105,000' },
		{ key: 110000, value: '$105,001 - $110,000' },
		{ key: 115000, value: '$110,001 - $115,000' },
		{ key: 120000, value: '$115,001 - $120,000' },
		{ key: 125000, value: '$120,001 - $125,000' },
		{ key: 130000, value: '$125,001 - $130,000' },
		{ key: 135000, value: '$130,001 - $135,000' },
		{ key: 140000, value: '$135,001 - $140,000' },
		{ key: 145000, value: '$140,001 - $145,000' },
		{ key: 150000, value: '$145,001 - $150,000' },
		{ key: 155000, value: '$150,001 - $155,000' },
		{ key: 160000, value: '$155,001 - $160,000' },
		{ key: 165000, value: '$160,001 - $165,000' },
		{ key: 170000, value: '$165,001 - $170,000' },
		{ key: 175000, value: '$170,001 - $175,000' },
		{ key: 180000, value: '$175,001 - $180,000' },
		{ key: 185000, value: '$180,001 - $185,000' },
		{ key: 190000, value: '$185,001 - $190,000' },
		{ key: 195000, value: '$190,001 - $195,000' },
		{ key: 200000, value: '$195,001 - $200,000' },
		{ key: 210000, value: '$200,001 - $210,000' },
		{ key: 220000, value: '$210,001 - $220,000' },
		{ key: 230000, value: '$220,001 - $230,000' },
		{ key: 240000, value: '$230,001 - $240,000' },
		{ key: 250000, value: '$240,001 - $250,000' },
		{ key: 260000, value: '$250,001 - $260,000' },
		{ key: 270000, value: '$260,001 - $270,000' },
		{ key: 280000, value: '$270,001 - $280,000' },
		{ key: 290000, value: '$280,001 - $290,000' },
		{ key: 300000, value: '$290,001 - $300,000' },
		{ key: 310000, value: '$300,001 - $310,000' },
		{ key: 320000, value: '$310,001 - $320,000' },
		{ key: 330000, value: '$320,001 - $330,000' },
		{ key: 340000, value: '$330,001 - $340,000' },
		{ key: 350000, value: '$340,001 - $350,000' },
		{ key: 360000, value: '$350,001 - $360,000' },
		{ key: 370000, value: '$360,001 - $370,000' },
		{ key: 380000, value: '$370,001 - $380,000' },
		{ key: 390000, value: '$380,001 - $390,000' },
		{ key: 400000, value: '$390,001 - $400,000' },
		{ key: 420000, value: '$400,001 - $420,000' },
		{ key: 440000, value: '$420,001 - $440,000' },
		{ key: 460000, value: '$440,001 - $460,000' },
		{ key: 480000, value: '$460,001 - $480,000' },
		{ key: 500000, value: '$480,001 - $500,000' },
		{ key: 520000, value: '$500,001 - $520,000' },
		{ key: 540000, value: '$520,001 - $540,000' },
		{ key: 560000, value: '$540,001 - $560,000' },
		{ key: 580000, value: '$560,001 - $580,000' },
		{ key: 600000, value: '$580,001 - $600,000' },
		{ key: 620000, value: '$600,001 - $620,000' },
		{ key: 640000, value: '$620,001 - $640,000' },
		{ key: 660000, value: '$640,001 - $660,000' },
		{ key: 680000, value: '$660,001 - $680,000' },
		{ key: 700000, value: '$680,001 - $700,000' },
		{ key: 720000, value: '$700,001 - $720,000' },
		{ key: 740000, value: '$720,001 - $740,000' },
		{ key: 760000, value: '$740,001 - $760,000' },
		{ key: 780000, value: '$760,001 - $780,000' },
		{ key: 800000, value: '$780,001 - $800,000' },
		{ key: 820000, value: '$800,001 - $820,000' },
		{ key: 840000, value: '$820,001 - $840,000' },
		{ key: 860000, value: '$840,001 - $860,000' },
		{ key: 880000, value: '$860,001 - $880,000' },
		{ key: 900000, value: '$880,001 - $900,000' },
		{ key: 920000, value: '$900,001 - $920,000' },
		{ key: 940000, value: '$920,001 - $940,000' },
		{ key: 960000, value: '$940,001 - $960,000' },
		{ key: 980000, value: '$960,001 - $980,000' },
		{ key: 1000000, value: '$980,001 - $1,000,000' },
		{ key: 1100000, value: '$1,000,001 - $1,100,000' },
		{ key: 1200000, value: '$1,100,001 - $1,200,000' },
		{ key: 1300000, value: '$1,200,001 - $1,300,000' },
		{ key: 1400000, value: '$1,300,001 - $1,400,000' },
		{ key: 1500000, value: '$1,400,001 - $1,500,000' },
		{ key: 1600000, value: '$1,500,001 - $1,600,000' },
		{ key: 1700000, value: '$1,600,001 - $1,700,000' },
		{ key: 1800000, value: '$1,700,001 - $1,800,000' },
		{ key: 1900000, value: '$1,800,001 - $1,900,000' },
		{ key: 2000000, value: '$1,900,001 - $2,000,000' },
		{ key: 2250000, value: '$2,000,001 - $2,250,000' },
		{ key: 2500000, value: '$2,250,001 - $2,500,000' },
		{ key: 2750000, value: '$2,500,001 - $2,750,000' },
		{ key: 3000000, value: '$2,750,001 - $3,000,000' },
		{ key: 3250000, value: '$3,000,001 - $3,250,000' },
		{ key: 3500000, value: '$3,250,001 - $3,500,000' },
		{ key: 3750000, value: '$3,500,001 - $3,750,000' },
		{ key: 4000000, value: '$3,750,001 - $4,000,000' },
		{ key: 4250000, value: '$4,000,001 - $4,250,000' },
		{ key: 4500000, value: '$4,250,001 - $4,500,000' },
		{ key: 4750000, value: '$4,500,001 - $4,750,000' },
		{ key: 5000000, value: '$4,750,001 - $5,000,000' },
		{ key: 5000001, value: 'Over $5,000,000' },
	],
	firstMortgageBalances: [
		{ key: 60000, value: '$60,000 or less' },
		{ key: 65000, value: '$60,001 - $65,000' },
		{ key: 70000, value: '$65,001 - $70,000' },
		{ key: 75000, value: '$70,001 - $75,000' },
		{ key: 80000, value: '$75,001 - $80,000' },
		{ key: 85000, value: '$80,001 - $85,000' },
		{ key: 90000, value: '$85,001 - $90,000' },
		{ key: 95000, value: '$90,001 - $95,000' },
		{ key: 100000, value: '$95,000 - $100,000' },
		{ key: 105000, value: '$100,001 - $105,000' },
		{ key: 110000, value: '$105,001 - $110,000' },
		{ key: 115000, value: '$110,001 - $115,000' },
		{ key: 120000, value: '$115,001 - $120,000' },
		{ key: 125000, value: '$120,001 - $125,000' },
		{ key: 130000, value: '$125,001 - $130,000' },
		{ key: 135000, value: '$130,001 - $135,000' },
		{ key: 140000, value: '$135,001 - $140,000' },
		{ key: 145000, value: '$140,001 - $145,000' },
		{ key: 150000, value: '$145,001 - $150,000' },
		{ key: 155000, value: '$150,001 - $155,000' },
		{ key: 160000, value: '$155,001 - $160,000' },
		{ key: 165000, value: '$160,001 - $165,000' },
		{ key: 170000, value: '$165,001 - $170,000' },
		{ key: 175000, value: '$170,001 - $175,000' },
		{ key: 180000, value: '$175,001 - $180,000' },
		{ key: 185000, value: '$180,001 - $185,000' },
		{ key: 190000, value: '$185,001 - $190,000' },
		{ key: 195000, value: '$190,001 - $195,000' },
		{ key: 200000, value: '$195,001 - $200,000' },
		{ key: 210000, value: '$200,001 - $210,000' },
		{ key: 220000, value: '$210,001 - $220,000' },
		{ key: 230000, value: '$220,001 - $230,000' },
		{ key: 240000, value: '$230,001 - $240,000' },
		{ key: 250000, value: '$240,001 - $250,000' },
		{ key: 260000, value: '$250,001 - $260,000' },
		{ key: 270000, value: '$260,001 - $270,000' },
		{ key: 280000, value: '$270,001 - $280,000' },
		{ key: 290000, value: '$280,001 - $290,000' },
		{ key: 300000, value: '$290,001 - $300,000' },
		{ key: 310000, value: '$300,001 - $310,000' },
		{ key: 320000, value: '$310,001 - $320,000' },
		{ key: 330000, value: '$320,001 - $330,000' },
		{ key: 340000, value: '$330,001 - $340,000' },
		{ key: 350000, value: '$340,001 - $350,000' },
		{ key: 360000, value: '$350,001 - $360,000' },
		{ key: 370000, value: '$360,001 - $370,000' },
		{ key: 380000, value: '$370,001 - $380,000' },
		{ key: 390000, value: '$380,001 - $390,000' },
		{ key: 400000, value: '$390,001 - $400,000' },
		{ key: 420000, value: '$400,001 - $420,000' },
		{ key: 440000, value: '$420,001 - $440,000' },
		{ key: 460000, value: '$440,001 - $460,000' },
		{ key: 480000, value: '$460,001 - $480,000' },
		{ key: 500000, value: '$480,001 - $500,000' },
		{ key: 520000, value: '$500,001 - $520,000' },
		{ key: 540000, value: '$520,001 - $540,000' },
		{ key: 560000, value: '$540,001 - $560,000' },
		{ key: 580000, value: '$560,001 - $580,000' },
		{ key: 600000, value: '$580,001 - $600,000' },
		{ key: 620000, value: '$600,001 - $620,000' },
		{ key: 640000, value: '$620,001 - $640,000' },
		{ key: 660000, value: '$640,001 - $660,000' },
		{ key: 680000, value: '$660,001 - $680,000' },
		{ key: 700000, value: '$680,001 - $700,000' },
		{ key: 720000, value: '$700,001 - $720,000' },
		{ key: 740000, value: '$720,001 - $740,000' },
		{ key: 760000, value: '$740,001 - $760,000' },
		{ key: 780000, value: '$760,001 - $780,000' },
		{ key: 800000, value: '$780,001 - $800,000' },
		{ key: 820000, value: '$800,001 - $820,000' },
		{ key: 840000, value: '$820,001 - $840,000' },
		{ key: 860000, value: '$840,001 - $860,000' },
		{ key: 880000, value: '$860,001 - $880,000' },
		{ key: 900000, value: '$880,001 - $900,000' },
		{ key: 920000, value: '$900,001 - $920,000' },
		{ key: 940000, value: '$920,001 - $940,000' },
		{ key: 960000, value: '$940,001 - $960,000' },
		{ key: 980000, value: '$960,001 - $980,000' },
		{ key: 1000000, value: '$980,001 - $1,000,000' },
		{ key: 1100000, value: '$1,000,001 - $1,100,000' },
		{ key: 1200000, value: '$1,100,001 - $1,200,000' },
		{ key: 1200001, value: 'Over $1,200,000' },
	]
}
